module.exports.AUTOMATIC_SIGNUP_VALIDATION_URL = '/signup_validation';
module.exports.UPDATE_EMAIL_URL = '/update_email';
